var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-team_svg__a",
    d: "M13.3 11.6v2.2h2.2v-2.2h-2.2zm-5.4 0v2.2h2.2v-2.2H7.9zm-5.3 0v2.2h2.2v-2.2H2.6zm5.3-7.3v2.2h2.2V4.3H7.9zm1.7 5.3v.8h.6c.6 0 1.1.5 1.1 1.1v2.2c0 .6-.5 1.1-1.1 1.1H7.9c-.6 0-1.1-.5-1.1-1.1v-2.2c0-.6.5-1.1 1.1-1.1h.6v-.8H4.3v.8h.6c.6 0 1.1.5 1.1 1.1v2.2c0 .6-.5 1.1-1.1 1.1H2.6c-.6 0-1.1-.5-1.1-1.1v-2.2c0-.6.5-1.1 1.1-1.1h.6v-.8c0-.6.5-1.1 1.1-1.1h4.2v-.8h-.6c-.6 0-1.1-.5-1.1-1.1V4.3c0-.6.5-1.1 1.1-1.1h2.2c.6 0 1.1.5 1.1 1.1v2.2c0 .6-.5 1.1-1.1 1.1h-.5v.8h4.2c.6 0 1.1.5 1.1 1.1v.8h.6c.6 0 1.1.5 1.1 1.1v2.2c0 .6-.5 1.1-1.1 1.1h-2.2c-.6 0-1.1-.5-1.1-1.1v-2.2c0-.6.5-1.1 1.1-1.1h.6v-.7H9.6z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-team_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-team_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crm-team_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-team_svg__c",
    d: "M-674-1677.9H750v1994H-674z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-team_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-team_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#crm-team_svg__d)",
    d: "M-3.6-1.8h25.2V20H-3.6z"
  }))));
}

export default SvgCrmTeam;